/**
 * 견적서·구매 서류(base64 PDF) 다운로드 공용 유틸.
 * QuotationGenerator(애드프로 랜딩)와 BulkPurchasePage(단체 구매)가 함께 쓴다.
 */
import JSZip from 'jszip';

export const base64ToUint8Array = (pdfBase64) => {
  const byteChars = atob(pdfBase64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  return new Uint8Array(byteNumbers);
};

export const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const HWPX_MIME = 'application/hwp+zip';

/** 품의서·기안문은 편집용 한글(.hwpx) 원본도 함께 오므로 확장자로 MIME을 고른다. */
export const documentMimeType = (filename = '') => (
  /\.hwpx$/i.test(filename) ? HWPX_MIME : 'application/pdf'
);

export const downloadBase64Pdf = (pdfBase64, filename) => {
  if (!pdfBase64 || !filename) return;
  const blob = new Blob([base64ToUint8Array(pdfBase64)], { type: documentMimeType(filename) });
  triggerDownload(blob, filename);
};

/** 서류가 1개면 파일 그대로, 여러 개면 ZIP으로 묶어 내려받는다. */
export const downloadDocumentPackage = async (docs, schoolName) => {
  const validDocs = docs.filter((doc) => doc?.content && doc?.filename);
  if (validDocs.length === 0) return;
  if (validDocs.length === 1) {
    downloadBase64Pdf(validDocs[0].content, validDocs[0].filename);
    return;
  }

  const zip = new JSZip();
  validDocs.forEach((doc) => {
    zip.file(doc.filename, base64ToUint8Array(doc.content));
  });
  const safeSchoolName = (schoolName || '학교').replace(/[\\/:*?"<>|]/g, '_');
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const blob = await zip.generateAsync({ type: 'blob' });
  triggerDownload(blob, `왓퀴즈AI_구매서류_${safeSchoolName}_${today}.zip`);
};
